export default "__VITE_ASSET__$nNuNnHg__"